import React from 'react';
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import Card from "../../../shared/components/Card";
import CardBody from "../../../shared/components/CardBody";
import {I18nUtils} from "../../../../i18n/I18nUtils";
import Row from "../../../shared/components/Row";
import RouterUtils from "../../../shared/routing/RouterUtils";
import {PsRoutes} from "../../../shared/routing/Routes";
import ExportOutsourceDocsCardTabOutsource from "./ExportOutsourceDocsCardTabOutsource";
import ExportOutsourceDocsCardTabWorkers from "./ExportOutsourceDocsCardTabWorkers";
import ExportOutsourceDocsCardTabMachines from "./ExportOutsourceDocsCardTabMachines";
import ExportOutsourceDocsCardTabMonthly from "./ExportOutsourceDocsCardTabMonthly";
import ExportOutsourceDocsCardTabLinked from "./ExportOutsourceDocsCardTabLinked";

class ExportOutsourceDocsCard extends React.Component {


  renderExportButton() {
    if (this.props.enableExport) {
      return(
        <Link
          to={RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DOCUMENTS_EXPORT_CONFIRM)}
          className={'btn btn-info btn-lg waves-effect waves-float'}
        >{I18nUtils.tr('TR_EXPORTAR_SELECCIONADOS').toUpperCase()}</Link>
      );
    }
  }

  render() {
    return (
      <Row>
        <Card colWidth={'col-md-12'} loading={this.props.importOutsourcesLoading}>
          <CardBody className={'table-responsive'}>
            <ul className="nav nav-tabs" role="tablist">
              {ExportOutsourceDocsCardTabOutsource.renderTabHeader()}
              {ExportOutsourceDocsCardTabWorkers.renderTabHeader()}
              {ExportOutsourceDocsCardTabMachines.renderTabHeader()}
              {ExportOutsourceDocsCardTabMonthly.renderTabHeader()}
              {ExportOutsourceDocsCardTabLinked.renderTabHeader()}
            </ul>

            <div className="tab-content">
              <ExportOutsourceDocsCardTabOutsource companyId={this.props.outsourceId}/>
              <ExportOutsourceDocsCardTabWorkers companyId={this.props.outsourceId}/>
              <ExportOutsourceDocsCardTabMachines companyId={this.props.outsourceId} />
              <ExportOutsourceDocsCardTabMonthly companyId={this.props.outsourceId} />
              <ExportOutsourceDocsCardTabLinked companyId={this.props.outsourceId} />
            </div>

            <div className="text-right">
              {this.renderExportButton()}
            </div>

          </CardBody>
        </Card>
      </Row>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  let exportCount = 0;
  exportCount += state.exportOutsourceDocs.outsourceDocuments.length;
  exportCount += state.exportOutsourceDocs.workers.length;
  exportCount += state.exportOutsourceDocs.machines.length;
  exportCount += state.exportOutsourceDocs.monthlyDocuments.length;
  exportCount += state.exportOutsourceDocs.linkedDocuments.length;
  return {
    enableExport: exportCount > 0,
  }
};


export default connect(mapStateToProps)(ExportOutsourceDocsCard)

ExportOutsourceDocsCard.propTypes = {
  outsourceId: PropTypes.string.isRequired,
};

ExportOutsourceDocsCard.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/outsource/components/export/ExportOutsourceDocsCard.js